var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table-responsive" }, [
    _c("table", { staticClass: "table trips-table", class: _vm.tableClass }, [
      _c("thead", { staticClass: "thead-light" }, [
        _c(
          "tr",
          [
            _vm._l(_vm.columnCount, function (n) {
              return _c("th", { key: n, attrs: { scope: "col" } }, [
                _c("div", {
                  staticClass: "skeleton-box",
                  staticStyle: { height: "20px", width: "80%" },
                }),
              ])
            }),
            _vm._v(" "),
            _vm.hasActions
              ? _c("th", { attrs: { scope: "col" } }, [
                  _c("div", {
                    staticClass: "skeleton-box",
                    staticStyle: { height: "20px", width: "60px" },
                  }),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.rowCount, function (row) {
          return _c(
            "tr",
            { key: row },
            [
              _vm._l(_vm.columnCount, function (col) {
                return _c("td", { key: col }, [
                  _c("div", {
                    staticClass: "skeleton-box",
                    style: `height: 18px; width: ${_vm.getRandomWidth()}%;`,
                  }),
                ])
              }),
              _vm._v(" "),
              _vm.hasActions ? _c("td", [_vm._m(0, true)]) : _vm._e(),
            ],
            2
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex gap-2" }, [
      _c("div", {
        staticClass: "skeleton-box",
        staticStyle: { height: "30px", width: "30px", "border-radius": "4px" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "skeleton-box",
        staticStyle: { height: "30px", width: "30px", "border-radius": "4px" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "skeleton-box",
        staticStyle: { height: "30px", width: "30px", "border-radius": "4px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }